import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Sales manager',
  [ManagerRole.SalesLeadership]: 'Sales Leadership',
  [ManagerRole.ContentManager]: 'Content manager',
  [ManagerRole.OnboardingManager]: 'Onboarding manager',
  [ManagerRole.OccAgent]: 'Call-center agent',
};
